import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import { createAppRouter } from './router';
import store from './store'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import DefaultLayout from './layouts/Default.vue'
import DashboardLayout from './layouts/Dashboard.vue'
import DashboardRTLLayout from './layouts/DashboardRTL.vue'
import DefaultProfile from './layouts/DefaultProfile.vue'
import i18n from '../createI18n'
import VueCookies from 'vue3-cookies'
import { useCookies } from "vue3-cookies"
import vue3GoogleLogin from 'vue3-google-login'
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

/** CSS */
import '../global.js'
import { initFacebookSdk } from '@/utils/facebookSdk'
const { cookies } = useCookies()
const app = createApp(App)

// Prefetch Facebook SDK (không block app nếu thiếu App ID)
initFacebookSdk().catch((err) => {
  console.warn('[Facebook SDK]', err?.message || err)
})
// const router = await createAppRouter();

app.component("layout-default", DefaultLayout);
app.component("layout-dashboard", DashboardLayout);
app.component("layout-dashboard-rtl", DashboardRTLLayout);
app.component("layout-default-profile", DefaultProfile);

app.config.globalProperties._cookies = cookies
app.config.globalProperties._lenguage = i18n
app.config.globalProperties._router = router
app.use(VueCookies, {
    expireTimes: "8h"
});
app.use(vue3GoogleLogin, {
    clientId: 'YOUR_GOOGLE_CLIENT_ID'
})
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            prefix: 'p',
            darkModeSelector: 'system',
            cssLayer: {
                name: 'primevue',
                order: 'tailwind-base, primevue, tailwind-utilities'
            }
        }
    }
});

const vuetify = createVuetify({
    components,
    directives
  })
app.use(Antd)
.use(store)
.use(router)
.use(i18n)
.use(vuetify)
.mount('#app')
